module.exports = __webpack_public_path__ + "img/face-drooling.fc255b2a.svg";